<template>
  <div class="ivu-back-top-new" :class="classes" :style="styles">
    <div class="item qrcode">
      <Dropdown class="ivu-dropdown-new" placement="left">
        <div class="qrcode-mini-img">
          <img class="qrcode-mini"  :src="require('@/assets/img/qrcode-mini.png')" alt="">
        </div>
        <DropdownMenu class="drop-detail" slot="list">
          <div class="qrcode-item">
            <img class="qrcode-img" :src="require('@/assets/img/qrcode-miniapp.png')" alt="">
            <div class="qrcode-tip">
              <p>微信扫一扫打开</p>
              <p><b>一招建材小程序</b></p>
            </div>
          </div>
          <div class="qrcode-item">
            <img class="qrcode-img" :src="require('@/assets/img/qrcode.png')" alt="">
            <div class="qrcode-tip">
              <p>微信扫一扫关注</p>
              <p><b>一招建材公众号</b></p>
            </div>
          </div>
        </DropdownMenu>
      </Dropdown>
    </div>
    <div class="item to-top" @click="back">
      <Icon class="active" type="ios-arrow-up" />
    </div>
    <!-- <div :class="innerClasses">
      <i class="ivu-icon ivu-icon-ios-arrow-up"></i>
    </div> -->
  </div>
</template>
<script>
import { scrollTop } from '@/utils/tools'
const prefixCls = 'ivu-back-top'

export default {
  props: {
    height: {
      type: Number,
      default: 400,
    },
    bottom: {
      type: Number,
      default: 30,
    },
    right: {
      type: Number,
      default: 30,
    },
    duration: {
      type: Number,
      default: 1000,
    },
  },
  data() {
    return {
      backTop: false,
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll, false)
    window.addEventListener('resize', this.handleScroll, false)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll, false)
    window.removeEventListener('resize', this.handleScroll, false)
  },
  computed: {
    classes() {
      return [
        `${prefixCls}`,
        {
          [`${prefixCls}-show`]: this.backTop,
        },
      ]
    },
    styles() {
      return {
        bottom: `${this.bottom}px`,
        right: `${this.right}px`,
      }
    },
    innerClasses() {
      return `${prefixCls}-inner`
    },
  },
  methods: {
    handleScroll() {
      this.backTop = window.pageYOffset >= this.height
    },
    back() {
      const sTop = document.documentElement.scrollTop || document.body.scrollTop
      scrollTop(window, sTop, 0, this.duration)
      this.$emit('on-click')
    },
  },
}
</script>

<style lang="less">
.ivu-back-top-new .item {
  border: 1px solid #E8E8E8;
  background: #fff;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;



  &.qrcode {
    border-bottom: none;
    color: @theme-code;
    .qrcode-mini-img {
      width: 40px;
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      img{
        width: 16px;
        height: 16px;
        display: inline-block;
      }
    }

    .qrcode-img {
      margin-right: 15px;
      width: 120px;
      height: 120px;
      display: inline-block;
      margin: auto;
    }

    .qrcode-tip {
      p {
        margin-bottom: 5px;
      }
    }

    .drop-detail {
      text-align: center !important;
      font-size: 12px;
      color: #222;
      display: flex;

      .qrcode-item {
        padding: 5px 10px 5px 5px;
      }
    }
  }
}
.ivu-back-top-new {
  .to-top {
    /deep/.ivu-back-top i{
      padding: 0;
    }
  }
} 
</style>



// WEBPACK FOOTER //
// src/components/footer/BackTop.vue